import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePurchaseListModel } from "../purchaseListModel";
import { IPurchaseListDetail } from "../purchaseListService";
import useNavModel from "@/model/navModel";
import { usePurchasesDetailModel } from "@/views/purchases/view/details/purchasesDetailModel";
import { formatNum } from "@/utils/utils";
import moment from "moment";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = usePurchaseListModel();
    const { replaceNav } = useNavModel(() => []);
    const { updateFormVal } = usePurchasesDetailModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IPurchaseListDetail> = [
        {
            title: '序号',
            width: 60,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '采购合同号',
            width: 160,
            dataIndex: 'purchaseCode',
            fixed: "left",
            ellipsis: true,
            render: (t, record) => <span className="label-span" onClick={() => { updateFormVal("edit", null); record.code && replaceNav("6-5", "4-2", { id: record.code, mode: "edit" }, true) }}>{t}</span>
        }, {
            title: '供应商名称',
            width: 160,
            dataIndex: 'supplierName',
            ellipsis: true,
        }, {
            title: '采购合同金额',
            width: 200,
            dataIndex: "amountTotal",
            render: (t, r) => `${r.currency}${formatNum(t)}`
        }, {
            title: '结算日期',
            width: 180,
            dataIndex: 'settlementTime',
            render: (t) => moment(t).format("YYYY-MM-DD")
        }, {
            title: '结算金额',
            width: 100,
            dataIndex: 'amountTotal',
            render: (t, r) => `${r.currency}${formatNum(t)}`
        },
        //  {
        //     title: '采购合同总金额',
        //     width: 100,
        //     dataIndex: 'amountTotal',
        // },
        // {
        //     title: '退税金额',
        //     width: 100,
        //     dataIndex: '', //待确认
        // }, 
        // {
        //     title: '不含税采购合同金额',
        //     width: 100,
        //     dataIndex: '',//待确认
        // }
    ];


    // //点击行选高亮
    // const onRow = (code: string) => {
    //     let findIndex = selectedRowKeys.indexOf(code);
    //     let newSelectedRowKeys = [...selectedRowKeys];
    //     if (findIndex === -1) {
    //         newSelectedRowKeys.push(code);
    //         setSelectedRowKeys(newSelectedRowKeys);
    //     } else {
    //         newSelectedRowKeys.splice(findIndex, 1);
    //         setSelectedRowKeys(newSelectedRowKeys);
    //     }
    // };


    return (
        <Table
            rowKey={record => record.code}
            loading={loading}
            // rowSelection={{
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.code).filter(item => item !== "listTotalAmount");
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.code),
            //     selectedRowKeys: selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.code),
            //     onContextMenu: (e) => {
            //         e.preventDefault();
            //         setSelectedRowKeys([record.code]);
            //     }
            // })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
